import { ChangeDetectorRef, Component, OnInit, NgZone } from '@angular/core';
import { ProfileService, UtilService, Data } from '@app/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EmailNotificationsService } from '@app/core/services/email-notifications.service';
import { User } from '@app/models/user.model';

@Component({
  selector: 'app-user-profile-fans',
  templateUrl: './user-profile-fans.component.html',
  styleUrls: ['./user-profile-fans.component.scss'],
})
export class UserProfileFansComponent implements OnInit {
  fans: any[] = [];
  userId: any;
  me: any;

  currentPage = 1;
  totalPages = 0;
  memberSortOptions: any[] = [];
  query = '';

  data: any = {
    total: 0,
    rqing: false,
    currentPage: 1,
    lastPage: 1,
    current_page: 1,
    first_page_url: '',
    from: 1,
    next_page_url: '',
    per_page: 1,
    prev_page_url: '',
    to: 1,
    last_page: 1,
    sort: null,
  };

  constructor(
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private toast: ToastrService,
    private ngZone: NgZone,
    private router: Router,
    private util: UtilService,
    private dataService: Data,
    private emailNotificationsService: EmailNotificationsService
  ) {}

  ngOnInit(): void {
    this.memberSortOptions = this.util.memberSortOptions;
    this.data.sort = this.memberSortOptions[0];

    this.activatedRoute.parent!.params.subscribe((params) => {
      this.fans = [];
      this.userId = params.id;
      this.onLoad();

      this.profileService.getUser(this.userId).subscribe((response) => {
        this.dataService.profileUserName = response.screen_name;
      });
    });
  }

  public navigate(commands: any[]): void {
    this.ngZone.run(() => this.router.navigate(commands));
  }

  onLoad(): void {
    if (this.userId) {
      this.getItems(null);
    } else {
      this.profileService.getUserProfile().subscribe((user: User) => {
        this.userId = user.id;
        this.me = user;
        this.getItems(null);
      });
    }
  }

  getItems(sort: any): void {
    if (sort) this.data.sort = sort;

    this.data.rqing = true;
    this.currentPage = 1;

    this.profileService
      .getUserFans(
        this.userId,
        this.currentPage,
        10,
        'screen_name',
        this.data.sort.asc,
        this.query
      )
      .subscribe((response) => {
        this.fans = response.data;
        this.data = response;
        this.data.rqing = false;
        this.totalPages = this.data.last_page;
        this.detectChanges();
      });
  }

  getPrevFans(): void {
    if (this.data.rqing || this.currentPage <= 1) {
      this.detectChanges();
      return;
    }

    this.currentPage--;
    scrollTo(0, 500);

    this.data.rqing = true;
    this.detectChanges();

    this.profileService
      .getUserFans(
        this.userId,
        this.currentPage,
        10,
        'screen_name',
        this.data.sort.asc,
        this.query
      )
      .subscribe((response) => {
        this.fans = response.data;
        this.data = response;
        this.totalPages = this.data.last_page;
        this.data.rqing = false;
        this.detectChanges();
      });
  }

  getNextFans(): void {
    if (this.data.rqing || this.currentPage === this.totalPages) return;

    this.currentPage++;
    scrollTo(0, 500);

    this.data.rqing = true;
    this.detectChanges();

    this.profileService
      .getUserFans(
        this.userId,
        this.currentPage,
        10,
        'screen_name',
        this.data.sort.asc,
        this.query
      )
      .subscribe((response) => {
        this.fans = response.data;
        this.data = response;
        this.totalPages = this.data.last_page;
        this.data.rqing = false;
        this.detectChanges();
      });
  }

  getLastPageFromURL(url: string): string {
    const pos = url.lastIndexOf('=');
    return url.substring(pos + 1);
  }

  detectChanges(): void {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  unfavoriteMember(profile: any): void {
    this.profileService.unfavoriteMember(profile.id).subscribe((response) => {
      if (response.success) {
        profile.favorited = true;
        this.toast.success(
          `${response.model.screen_name} removed from favorites.`
        );
      } else {
        this.toast.error(response.message);
      }
    });
  }

  favoriteMember(profile: any): void {
    this.profileService.favoriteMember(profile.id).subscribe((response) => {
      if (response.success) {
        profile.favorited = true;
        this.toast.success(`${response.model.screen_name} added to favorites.`);

        if (profile.newsletter) {
          this.emailNotificationsService.emailFavoriteNotificationV2(
            profile.email,
            profile.recipient_name,
            this.me.screen_name,
            this.me.id,
            this.me.photo.replace('https://', '')
          );
        }
      } else {
        this.toast.error(response.message);
      }
    });
  }

  navMessage(id: any): void {
    this.navigate([`/d/private-message/inbox/${id}`]);
  }

  navProfile(id: any): void {
    this.navigate([`/d/profile/${id}`]);
  }

  onSearch(query: string): void {
    this.query = query;
    this.data.sort = this.memberSortOptions[0];
    this.getItems(this.data.sort);
  }
}
